/**
 * Store for `DATA.dimensions`
 * @module
 */

var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');
var freeze = require('../utils/freeze');

/**
 * Holds the data for every layer
 */
module.exports = {
  initialize: function() {
    this.__state = {} as any;

    this.on(actionTypes.DATA_LOADED, this.__loadData);
  },

  /**
   * Loads layer data into the store state
   * @param {Object} payload
   * @param {ClientData} payload.data
   * @private
   */
  __loadData: function(payload:any) {
    if (_.isEmpty(payload.data.dimensions)) {
      return;
    }
    _.each(payload.data.dimensions, _.bind(function(dimension) {
      freeze.deepFreeze(dimension);
      this.__state[dimension.id] = dimension;
    }, this));
    this.emitChange();
  },

  /**
   * @return {Dimension[]}
   */
  getAll: function(): Dimension[] {
    return freeze.safeReference(_.values(this.__state));
  },

  /**
   * @param {string} id
   * @return {Dimension|undefined}
   */
  getById: function(id:string): Dimension|undefined {
    return freeze.safeReference(this.__state[id]);
  },

  /**
   * @param {string} apiName
   * @return {Dimension|undefined}
   */
  getByApiName: function(apiName:string): Dimension|undefined {
    return freeze.safeReference(_.find(_.values(this.__state), {
      apiName: apiName,
    }));
  },
};
